import React, { Fragment } from 'react';

import { Typography, Box as MuiBox } from '@material-ui/core';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import SmartphoneIcon from '@material-ui/icons/Smartphone';


import { EditIcon, VisibilityIcon, VisibilityOffIcon } from 'components/CustomIcons';
import { ComponentWithPageLanguageProps } from 'utils/enhancers/withPageLanguage';

import { Box, DragIndicatorIcon, FlagIcon } from './style';
import { Tooltip } from '../InfoTooltip/style';

interface SortableEntranceAnimationListProps extends ComponentWithPageLanguageProps {
  list: any[];
  handleVisibility: (index: number) => void;
  toggleDialog: () => void;
  setDialogSettings: (index: number) => void;
}

export function SortableEntranceAnimationList({
  list,
  handleVisibility,
  toggleDialog,
  setDialogSettings,
  pageLanguageTabValue
}: SortableEntranceAnimationListProps): JSX.Element {
  return (
    <>
      {list.map((item, index) => (
        <Box key={item.actionType} className={item.hidden ? 'disabled' : ''}>
          <DragIndicatorIcon className="entrance-animation-icon" />
          <Box className="no-margin" justifyContent="space-between" style={{ width: '100%' }}>
            <Box className="no-minHeight no-margin">
              <MuiBox display="flex" alignItems="center" mr={4} style={{ lineHeight: '0' }}>
                <MuiBox mr={1.5}>
                  <DesktopWindowsIcon color="action" fontSize="small" />
                </MuiBox>
                <Typography>{item.desktop.title[pageLanguageTabValue ?? 0].value}</Typography>
              </MuiBox>
              <MuiBox display="flex" alignItems="center" mr={4} style={{ lineHeight: '0' }}>
                <MuiBox mr={1.5}>
                  <SmartphoneIcon color="action" fontSize="small" />
                </MuiBox>
                <Typography>{item.mobile.title[pageLanguageTabValue ?? 0].value}</Typography>
              </MuiBox>
              {item.complete && (
                <Tooltip placement="top" title="The animation guide considered completed and won’t shown again.">
                  <FlagIcon fontSize="small" />
                </Tooltip>
              )}
            </Box>
            <Box className="no-minHeight no-margin">
              <EditIcon
                fontSize="small"
                color={item.hidden ? 'disabled' : 'primary'}
                onClick={() => {
                  toggleDialog();
                  setDialogSettings(index);
                }}
              />
              {!item.hidden ?
                <VisibilityIcon
                  fontSize="small"
                  color={item.hidden ? 'disabled' : 'primary'}
                  onClick={() => handleVisibility(index)}
                /> :
                <VisibilityOffIcon
                  fontSize="small"
                  color={item.hidden ? 'disabled' : 'primary'}
                  onClick={() => handleVisibility(index)}
                />
              }
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
}
